window.addEventListener("load", () => {
    const productOptions = document.querySelectorAll(".product-single-option .option-label");
    let faqBtn = document.querySelector(".js-buy-with-prime-faq");
    let addCart = document.querySelector(".add-to-cart");

    if(productOptions.length > 0){
      if(productOptions[0].getAttribute('class').includes('active')){
          faqBtn.style.display = 'none';
          addCart.style.display = 'flex';
      } else {
          faqBtn.style.display = 'inline-flex';
          addCart.style.display = 'none';
      }
  
      productOptions.forEach((option) => {
          option.addEventListener("click", () => {
              let optionValue = option.dataset.value;
              if (optionValue && faqBtn) {
                  if (optionValue !== "NGN In House" && optionValue !== "Buy With Prime" && optionValue !== "NGN Prime") {
                      faqBtn.style.display = 'none';
                      addCart.style.display = 'flex';
                  } else if (optionValue === "NGN In House") {
                      faqBtn.style.display = 'none';
                      addCart.style.display = 'flex';
                  } else if (optionValue === "Buy With Prime" || optionValue === "NGN Prime") {
                      faqBtn.style.display = 'inline-flex';
                      addCart.style.display = 'none';
                  }
              }
          });
      });
    } else {
      let default_option = document.querySelectorAll("#product-option-default");
      let variant = default_option[0].value;
      if (variant === "Default Title"){
        faqBtn.style.display = 'none';
        addCart.style.display = 'flex';
      } else if (variant === "Buy With Prime") {
        faqBtn.style.display = 'inline-flex';
        addCart.style.display = 'none';
      }
    }
});
